/* eslint-disable */
// src/redux/store.js

import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";

const store = configureStore({
  reducer: {
    userReducer: userReducer,
  },
});

export default store;
